export default "08439069a43ebd62.jpg"